// extracted by mini-css-extract-plugin
export var drawerPaper = "_1j-0";
export var itemImage = "_1j-1";